/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Promotion extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Promotion;


// WEBPACK FOOTER //
// ./src/routes/promotion/index.js